module.exports = __webpack_public_path__ + "static/media/step5.430af9c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Pay3/images/sber/step5.png
// module id = 707
// module chunks = 0